export default __webpack_public_path__ + "static/media/card-7.07bde922.png";